import { ImgIcon } from "@panwds/react-ui";
import panw_aws_logo from '../../images/panw_aws_logo.png';
import SignUpV2 from "./SignUpV2";
import styles from './styles/Register.module.scss';
import bgImage from '../../images/login-background.png';
import getUrlParameter from "../../utils/GetUrlParameter";
import { NetworkWiredIcon, PolicyIcon, SettingsIcon } from "@panwds/icons";
import {useState, useEffect} from "react";
import { ProtectIcon, GearsIcon } from '../../images';


const Register = () => {
    const [hasCode, setHasCode] = useState("");

    return (
        <div style={{ backgroundImage: `url(${bgImage})` }} className={`${styles.backgroundCover} tw-relative tw-h-screen tw-w-full`}>
            {/* Icons in top left corner */}
            <div className={`${styles.iconsContainer}`}>
                <ImgIcon alt="Palo Design System" src={panw_aws_logo} size="xxl" />
            </div>

            {/* Content panel centered on page */}
            <div className={`${styles.contentPanel}`}>
                <div className={`${styles.contentChild} ${styles.inputContentV2}`}>
                    <SignUpV2 setHasCode={setHasCode}/>
                </div>
                <div className={`${styles.contentChild} ${styles.helpContentV2}`}>
                    {(hasCode === "Yes") ?
                    <>
                    <h3 className="tw-font-normal tw-mb-2 tw-text-lg">Pay-As-You-Go Subscription</h3>

                    <h2 className="tw-mb-4 tw-text-3xl">Complete Your Cloud NGFW Subscription</h2>

                    <div className="tw-leading-normal tw-text-md">Enter the Billing Subscription Code from your Strata Cloud Manager tenant to activate Pay-As-You-Go billing through your AWS account.</div>

                    <div className="tw-leading-normal tw-text-md tw-mb-4">This final step links your AWS account for seamless PAYG billing. Your existing firewalls, policies, and configurations within Strata Cloud Manager will not be affected.</div>

                    <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
                        <div className="tw-px-4">
                            <ImgIcon src={GearsIcon} alt="" size = "5xl"></ImgIcon>
                        </div>
                        <div className="tw-text-lg tw-space-y-2">
                            <div><b>Link Billing, Not Your Workflow:</b></div>
                            <div>Your management experience remains centralized in Strata Cloud Manager.</div>
                        </div>
                    </div>
                    <div className="tw-flex tw-items-center tw-gap-3 tw-mb-4">
                        <div className="tw-px-4">
                            <ImgIcon src={ProtectIcon} alt="" size = "5xl"></ImgIcon>
                        </div>
                        <div className="tw-text-lg tw-space-y-2">
                            <div><b>Ensure Uninterrupted Protection:</b></div>
                            <div>Your deployed firewalls will continue providing best-in-class security without disruption.</div>
                        </div>
                    </div>
                    <div>Need help? Contact <b>support@paloaltonetworks.com</b> or visit us at <a href="https://support.paloaltonetworks.com/Support/Index"> https://support.paloaltonetworks.com </a></div>
                    </>
                    :
                    <>
                    <div className="tw-font-normal tw-mb-2 tw-text-lg">30 Day Free Trial</div>

                    <h3 className="tw-mb-4 tw-text-3xl">The Palo Alto Networks Cloud NGFW for AWS </h3>

                    <div className="tw-leading-normal tw-text-md tw-mb-4">Start your 30-day free trial by setting up your tenant to immediately leverage Cloud Next-Generation Firewall capabilities in your AWS environment.</div>

                    <div className="tw-flex tw-items-center tw-gap-3">
                        <div className="tw-px-4">
                            <SettingsIcon size="xl" />
                        </div>
                        <div>
                            <div><b>Simple Setup</b></div>
                            <div className={`${styles.smallText}`}>No complex installation needed. Just fill in a few details to get your tenant ready.</div>
                        </div>
                    </div>

                    <div className="tw-flex tw-items-center tw-gap-3">
                        <div className="tw-px-4">
                            <NetworkWiredIcon size="xl" />
                        </div>
                        <div>
                            <div><b>Customize Your Security</b></div>
                            <div className={`${styles.smallText}`}>Configure your firewall settings to suit your unique security needs.</div>
                        </div>
                    </div>

                    <div className="tw-flex tw-items-center tw-gap-3">
                        <div className="tw-px-4">
                            <PolicyIcon size="xl" />
                        </div>
                        <div>
                            <div><b>Secure and Compliant</b></div>
                            <div className={`${styles.smallText}`}>Enjoy peace of mind knowing your data is protected in a secure and compliant environment.</div>
                        </div>
                    </div>

                    <div className="tw-mt-4">Once you set up your account for the Cloud NGFW, you'll be able to:</div>
                    <ul className={`${styles.featureList}`}>
                        <li>Deploy quickly and manage your firewall resources seamlessly in AWS.</li>
                        <li>Monitor firewall performance and health in real-time with integrated AWS CloudWatch.</li>
                        <li>Automate security tasks with advanced firewall-as-code capabilities using APIs, CloudFormation, and Terraform.</li>
                    </ul>

                    <div>Need help? Contact <b>support@paloaltonetworks.com</b> or visit us at <a href="https://support.paloaltonetworks.com/Support/Index"> https://support.paloaltonetworks.com </a></div>
                    </>}
                </div>
            </div>
        </div>
    );
};

export default Register;
